import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@instructure/ui-tooltip';
import { Modal } from '@instructure/ui-modal';
import { TruncateText } from '@instructure/ui-truncate-text';
import { Heading } from '@instructure/ui-heading';
import { View } from '@instructure/ui-view';
import { Button, CloseButton } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
export var AccommodationModal = /*#__PURE__*/function (_Component) {
  function AccommodationModal() {
    var _this2;
    _classCallCheck(this, AccommodationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AccommodationModal, [].concat(args));
    _defineProperty(_this2, "state", {
      isTruncated: false
    });
    _defineProperty(_this2, "handleUpdate", function (isTruncated) {
      if (_this2.state.isTruncated !== isTruncated) {
        _this2.setState({
          isTruncated: isTruncated
        });
      }
    });
    _defineProperty(_this2, "handleAccommodationsModalExited", function () {
      _this2.setState({
        isTruncated: false
      });
    });
    _defineProperty(_this2, "renderName", function (renderProps) {
      var focused = renderProps && renderProps.focused;
      return /*#__PURE__*/React.createElement(View, {
        "aria-hidden": "true",
        display: "inline-block",
        borderRadius: "small",
        position: "relative",
        withFocusOutline: _this2.state.isTruncated && focused,
        as: "div",
        tabIndex: _this2.state.isTruncated ? 0 : null
      }, /*#__PURE__*/React.createElement(TruncateText, {
        maxLines: 2,
        truncate: "character",
        onUpdate: _this2.handleUpdate
      }, _this2.props.studentName));
    });
    _defineProperty(_this2, "renderHeading", function () {
      if (_this2.props.atteqApplyChangesToCurrentQuizAttemptsEnabled) {
        return /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('Course Accommodation')), t('Course Accommodation'));
      }
      var _this2$props = _this2.props,
        mountNode = _this2$props.mountNode,
        studentName = _this2$props.studentName;
      if (!studentName) {
        return;
      }
      return /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement(ScreenReaderContent, null, studentName), _this2.state.isTruncated ? /*#__PURE__*/React.createElement(Tooltip, {
        renderTip: studentName,
        mountNode: mountNode
      }, _this2.renderName) : _this2.renderName());
    });
    _defineProperty(_this2, "saveAction", function () {
      _this2.props.onSubmit && _this2.props.onSubmit();
      _this2.props.closeModal();
    });
    _defineProperty(_this2, "cancelAction", function () {
      _this2.props.onDismiss && _this2.props.onDismiss();
      _this2.props.closeModal();
    });
    return _this2;
  }
  _inherits(AccommodationModal, _Component);
  return _createClass(AccommodationModal, [{
    key: "labelText",
    value: function labelText() {
      if (this.props.atteqApplyChangesToCurrentQuizAttemptsEnabled) {
        return t('Course Accommodation');
      }
      return this.props.studentName || t('Accommodations Modal');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        open = _this$props.open,
        closeModal = _this$props.closeModal,
        mountNode = _this$props.mountNode,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement(Modal, {
        open: open,
        label: this.labelText(),
        mountNode: mountNode,
        size: "small",
        onExited: this.handleAccommodationsModalExited
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(CloseButton, {
        onClick: closeModal,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      }), this.renderHeading()), /*#__PURE__*/React.createElement(Modal.Body, null, children), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.cancelAction,
        margin: "xxx-small",
        "data-automation": "sdk-moderation-cancel"
      }, t('Cancel')), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        onClick: this.saveAction,
        margin: "xxx-small",
        "data-automation": "sdk-moderation-save"
      }, t('Save'))));
    }
  }]);
}(Component);
_defineProperty(AccommodationModal, "propTypes", {
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  studentName: PropTypes.string,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
  mountNode: PropTypes.string,
  // this is just to fix chromatic
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  atteqApplyChangesToCurrentQuizAttemptsEnabled: PropTypes.bool.isRequired
});
_defineProperty(AccommodationModal, "defaultProps", {
  children: [],
  ellipsis: null,
  // placeholder for when different ellipsis are needed (ellipsis language-dependent)
  mountNode: null,
  onSubmit: null,
  onDismiss: null,
  studentName: null
});
export default AccommodationModal;